type GetWhoIndicatesLinkModel = {
	url: string;
};

export enum WhoIndicatesTagParametricEnum {
	HOME = 'banner_home',
	BOOKING = 'banner_agendamento',
	BILL = 'banner_boletos',
}

type GetWhoIndicatesLinkParams = {
	utm_medium?: WhoIndicatesTagParametricEnum;
};

interface GetWhoIndicatesLink {
	get: (params?: GetWhoIndicatesLinkParams) => Promise<GetWhoIndicatesLinkModel>;
}

export type {GetWhoIndicatesLink, GetWhoIndicatesLinkModel, GetWhoIndicatesLinkParams};
